export default function initializeMetricsToggle() {
    document.querySelectorAll('.ranking-card__metrics-toggle').forEach(btn => {
        btn.addEventListener('click', () => {
            const body = btn.closest('.ranking-card__body');
            if (!body) return;

            const isExpanded = body.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', String(isExpanded));

            const toggleText = btn.querySelector('.ranking-card__metrics-toggle-text');
            if (toggleText) {
                toggleText.textContent = isExpanded ? 'Zwiń' : 'Pokaż wszystkie';
            }
        });
    });
}
